import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { EraChatBot } from "./components/ERA";
import ReactGA from 'react-ga4';
import { clearThreadId } from "./shared/threadIdUtil";
import { ToastContainer } from "react-toastify";
import { JiraGenieBot } from "./components/ERA/JiraGenie/jiraGenie";
import { BuzzBucketBot } from "./components/ERA/BuzzBucket/buzzBucket";
import { TextSqlBot } from "./components/ERA/TextSql/textSql";
import { BuzzReportsAdminBot } from "./components/ERA/TextSql/buzzReportAdmin";
import { BuzzReportsDownloadBot } from "./components/ERA/TextSql/buzzReportsDownload";
import { EraV2ChatBot } from "./components/ERA/eraV2";

function App() {
  useEffect(() => {
    if (process.env?.REACT_APP_ENV === 'production') {
      const GA_ID = process.env?.REACT_APP_GA_ID;
      ReactGA.initialize([
        {
          trackingId: String(GA_ID)
        }
      ]);
    }

    const handleTabCloseOrRefresh = () => {
      clearThreadId();
      console.log("Thread ID cleared");
    };
    window.addEventListener("beforeunload", handleTabCloseOrRefresh);

    return () => {
      window.removeEventListener("beforeunload", handleTabCloseOrRefresh);
    };
   
  }, []);
  return (
    <BrowserRouter>
    <ToastContainer />
      <Routes>
        <Route path="/" element={<EraChatBot />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
